
import Hero from "@/components/Hero";

const AboutHero = () => {
  return (
    <Hero 
      title="Toetan naisi elu väljakutsetes ja nende muutmisel isiklikuks kasvuks."
      buttonText="Alusta enda teekonda"
      bgColor="bg-gradient-to-r from-kaija-sage to-kaija-peach"
    />
  );
};

export default AboutHero;
